import React from 'react';
import Icon from '../../Components/Icons/Icon';
import { Link } from 'react-router-dom';
import { useSession } from '../../Components/Session';
import { levels } from '../../Data/Admin';
import newMenu from '../newMenu';
import { classNames } from '../../Services/helpers';
import { useDialogues } from '../../Components/Dialogues';
import useHomeBadge from '../../Data/useHomeBadge';

const RedesignNavSections = ({ onNavigate }) => {
    const { confirm, featureUnavailable } = useDialogues();
    const {
        logout,
        isAdmin,
        isAdminSwitched,
        adminSwitchBack,
        setShowRedesign,
        showDarkMode,
        setShowDarkMode,
        hasFeature,
    } = useSession();
    const homeBadge = useHomeBadge();

    const afterNav = () => {
        onNavigate?.();
    };

    return (
        <>
            {newMenu.map((section) => (
                <div key={section.title} className="mb-6">
                    <div className="flex items-center mb-3">
                        <Icon
                            icon={section.icon}
                            size="1x"
                            className="fill-gray-800 dark:fill-gray-200 mr-3"
                            badge={section.notifications ? (homeBadge ? true : null) : null}
                        />
                        <h2 className="text-gray-800 dark:text-gray-200 font-bold text-base">{section.title}</h2>
                    </div>

                    <div className="ml-8 space-y-2">
                        {section.items.map((item) => {
                            const isLocked = item.feature && !hasFeature(item.feature);

                            if (isLocked) {
                                return (
                                    <div
                                        key={item.label}
                                        onClick={() => {
                                            featureUnavailable(item.feature);
                                            afterNav();
                                        }}
                                        className={classNames(
                                            'py-1 transition-colors text-left cursor-pointer flex items-center justify-between',
                                            'text-gray-400 dark:text-gray-500',
                                        )}
                                    >
                                        <span>{item.label}</span>
                                        <Icon icon="Lock" size="0.75x" className="fill-gray-400 dark:fill-gray-500" />
                                    </div>
                                );
                            }

                            return (
                                <Link
                                    key={item.label}
                                    to={item.disabled ? null : item.to}
                                    onClick={item.disabled ? null : afterNav}
                                    className={classNames(
                                        'block py-1 transition-colors text-left',
                                        item.disabled
                                            ? 'text-gray-400 dark:text-gray-500 cursor-not-allowed'
                                            : 'text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100',
                                    )}
                                >
                                    {item.label}
                                </Link>
                            );
                        })}
                    </div>
                </div>
            ))}

            {isAdmin(levels.READ_ONLY) && (
                <div className="mb-6">
                    <div className="flex items-center mb-3">
                        <Icon
                            icon="Wrench"
                            size="1x"
                            className="fill-gray-800 dark:fill-gray-200 mr-3"
                        />
                        <h2 className="text-gray-800 dark:text-gray-200 font-bold text-base">Admin</h2>
                    </div>

                    <div className="ml-8 space-y-2">
                        <Link
                            to="/admin"
                            onClick={afterNav}
                            className="block py-1 transition-colors text-left text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100"
                        >
                            Admin Panel
                        </Link>
                        {isAdminSwitched && (
                            <div
                                className="block py-1 transition-colors text-left text-red-600 cursor-pointer hover:text-red-700"
                                onClick={() => {
                                    adminSwitchBack();
                                    afterNav();
                                }}
                            >
                                Switch back
                            </div>
                        )}
                    </div>
                </div>
            )}

            <div className="border-t border-gray-200 dark:border-gray-700 my-4"></div>

            <div className="space-y-2">
                <div className="flex items-center py-1">
                    <Link to="/more" onClick={afterNav}>
                        <Icon icon="Gear" size="1x" className="fill-gray-800 dark:fill-gray-200 mr-3" />
                        <span className="text-gray-800 dark:text-gray-200">Settings</span>
                    </Link>
                </div>
                <div
                    className="flex items-center py-1 cursor-pointer"
                    onClick={() => confirm(
                        { theme: 'danger', title: 'Logout', message: 'Are you sure you want to logout?', confirmLabel: 'Logout' },
                        async () => {
                            await logout();
                            window.location.reload();
                        },
                    )}
                >
                    <Icon icon="ArrowLeftToBracket" size="1x" className="fill-gray-800 dark:fill-gray-200 mr-3" />
                    <span className="text-gray-800 dark:text-gray-200">Log Out</span>
                </div>
            </div>

            <div className="border-t border-gray-200 dark:border-gray-700 my-4"></div>

            <div className="flex justify-start gap-4">
                <button
                    type="button"
                    className="w-8 h-8 rounded-full flex items-center justify-center border border-gray-200 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                    onClick={() => confirm(
                        {
                            theme: 'warning',
                            title: 'Turn off redesign?',
                            message: 'Are you sure you want to turn off the redesign?',
                            confirmLabel: 'Turn off',
                            cancelLabel: 'Cancel',
                        },
                        () => setShowRedesign(false),
                    )}
                >
                    <Icon icon="Brush" size="1x" className="fill-gray-800 dark:fill-gray-200" />
                </button>
                <button
                    type="button"
                    className="w-8 h-8 rounded-full flex items-center justify-center border border-gray-200 dark:border-gray-600 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors"
                    onClick={() => setShowDarkMode(!showDarkMode)}
                >
                    <Icon icon={showDarkMode ? 'SunBright' : 'Moon'} size="1x" className="fill-gray-800 dark:fill-gray-200" />
                </button>
            </div>
        </>
    );
};

export default RedesignNavSections;
